import { AiShareTrigger } from "@/components/ai-assistant/ai-share-trigger";

import { useMayaSpace } from "../context/use-maya-space";

interface MayaShareTriggerProps {
  sessionId: string;
  triggerClassName?: string;
}

/** Share the open chat — through its space's share links, like its page. */
export const MayaShareTrigger = ({
  sessionId,
  triggerClassName,
}: MayaShareTriggerProps) => {
  const { history } = useMayaSpace();
  const [fetchShareLink, { isFetching }] = history.useLazyGetShareLink();
  const [createShareLink, { isLoading: isCreating }] =
    history.useCreateShareLink();
  const [revokeShareLink, { isLoading: isRevoking }] =
    history.useRevokeShareLink();
  return (
    <AiShareTrigger
      sessionId={sessionId}
      variant="icon"
      triggerClassName={triggerClassName}
      isFetching={isFetching}
      isCreating={isCreating}
      isRevoking={isRevoking}
      fetchShareLink={fetchShareLink}
      createShareLink={createShareLink}
      revokeShareLink={revokeShareLink}
    />
  );
};
